module.exports = __webpack_public_path__ + "static/media/keval.afbf13b8.svg";